import React from 'react';
import PropTypes from 'prop-types';
import RelatedLink from './RelatedLink';
import relatedLinkPropTypes from './RelatedLink/propTypes';
import './style.scss';

const RelatedLinks = ({title, relatedLinks}) => (
    <section className="related-links">
        <h2>{i18n.t('seo_sub_category.relatedLinks.title', {sub_category_title: title})}</h2>
        <ul>
            {relatedLinks.map((link, idx) => (
                <li key={idx}>
                    <RelatedLink {...link}/>
                </li>
            ))}
        </ul>
    </section>
);

RelatedLinks.propTypes = {
    relatedLinks: PropTypes.arrayOf(
        PropTypes.shape(relatedLinkPropTypes)
    )
};

RelatedLinks.defaultProps = {
    relatedLinks: []
};

export default RelatedLinks;



// WEBPACK FOOTER //
// ./src/components/RelatedLinks/index.js